import { useQuery } from '@tanstack/react-query'

import { api } from '@/shared/services/api'

interface CurrentUserRecord {
  email: string
  unconfirmed_email: string | null
}

export function useCurrentUserRecord() {
  const { data, refetch, isLoading } = useQuery({
    queryKey: ['/user'],
    queryFn: async () => {
      const { data } = await api.get('/user')
      return data
    },
    staleTime: 0
  })

  return {
    currentUser: (data?.record ?? null) as CurrentUserRecord | null,
    refetch,
    isLoading
  }
}
